import { IVariant } from 'services/variant';

export type IReturnProduct = IVariant & {
  quantity: number;
  lossAmount: number;
  unitPrice: number;
  salesProduct: string;
};

export enum ActionKind {
  SetReturnProducts = 'SET_RETURN_PRODUCTS',
  AddReturnProduct = 'ADD_RETURN_PRODUCT',
  RemoveReturnProduct = 'REMOVE_RETURN_PRODUCT',
  EditReturnProduct = 'EDIT_RETURN_PRODUCT',
  SetInvoice = 'SET_INVOICE',
}

export type Action =
  | { type: ActionKind.SetReturnProducts; payload: IReturnProduct[] }
  | { type: ActionKind.AddReturnProduct; payload: IReturnProduct }
  | { type: ActionKind.RemoveReturnProduct; payload: string }
  | { type: ActionKind.EditReturnProduct; payload: IReturnProduct }
  | { type: ActionKind.SetInvoice; payload: string };

interface IState {
  returnProducts: IReturnProduct[];
  selectedInvoice?: string;
}

export const initialState: IState = {
  returnProducts: [],
  selectedInvoice: undefined,
};

export const productReturnReducer = (state: IState, action: Action) => {
  switch (action.type) {
    case ActionKind.SetReturnProducts:
      return { ...state, returnProducts: action.payload };
    case ActionKind.AddReturnProduct:
      const isProductExist = state.returnProducts.find(
        (product) => product.productVariantId === action.payload.productVariantId
      );
      if (isProductExist) {
        return state;
      }
      return { ...state, returnProducts: [...state.returnProducts, action.payload] };
    case ActionKind.RemoveReturnProduct:
      const products = state.returnProducts.filter(
        (product) => product.productVariantId !== action.payload
      );
      return { ...state, returnProducts: products };
    case ActionKind.EditReturnProduct:
      const modifiedProducts = state.returnProducts.map((product) =>
        product.productVariantId === action.payload.productVariantId
          ? { ...action.payload }
          : { ...product }
      );
      return { ...state, returnProducts: modifiedProducts };
    case ActionKind.SetInvoice:
      return { ...state, selectedInvoice: action.payload };
    default:
      return state;
  }
};
